import { DataSource, HorizontalSpacer, Layout, Switch, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutTrimbleVisibilityDataExportControl extends Layout {
    horizontalspacer1: HorizontalSpacer;
    sourceTenfourControl: DataSource;
    sourceTenfourEmailControl: DataSource;
    switchIsActive: Switch;
    tableTrimbleVisibilityControlEmail: Table;
    textboxAddress: Textbox;
    textboxCommunicationExporBy: Textbox;
    textboxFilename: Textbox;
    textboxPassword: Textbox;
    textboxPort: Textbox;
    textboxRemoteDir: Textbox;
    textboxRemoteFile: Textbox;
    textboxUsername: Textbox;
}
